import React, {

    useEffect,

    useState,

    useRef

} from "react";

import {

    functions

} from "../../../constants/common-functions";

import {

    faBuilding,

    faChevronUp,

    faChevronDown

} from "@fortawesome/free-solid-svg-icons";

import {

    FontAwesomeIcon

} from "@fortawesome/react-fontawesome";


/* =========================================================
   COMPONENT
   ========================================================= */

export default function ScanNavigator(props)

{

    const {

        buildingId,

        switchScan,

        rightDrawerOpen,

        aiDrawerVisible,

        setAiDrawerVisible

    } = props;


    /* =========================================================
       STATE
       ========================================================= */

    const [navigator, setNavigator] =

        useState(null);

    const [collapsed, setCollapsed] =

        useState(false);

    const [side, setSide] =

        useState(

            localStorage.getItem("scanNavigatorSide")

            ||

            "left"

        );

    const [dragging, setDragging] =

        useState(false);

    const [position, setPosition] =

        useState(

        {

            x:

                side === "left"

                    ? 90

                    : window.innerWidth - 250,

            y:

                100

        });

    const [visible, setVisible] =

        useState(false);

    const [selectedFloorId, setSelectedFloorId] =

        useState(null);

    const dragOffset =

        useRef(

        {

            x: 0,

            y: 0

        });


    const isLocalHost =

        window.location.hostname === "localhost"

        ||

        window.location.hostname === "127.0.0.1";


    /* =========================================================
       DELAYED DISPLAY
       ========================================================= */

    useEffect(

        function()

        {

            const timer =

                setTimeout(

                    function()

                    {

                        setVisible(true);

                    },

                    7000

                );

            return function()

            {

                clearTimeout(timer);

            };

        },

        []

    );


    /* =========================================================
       LOAD NAVIGATOR
       ========================================================= */

    useEffect(

        function()

        {

            if(!buildingId)

            {

                return;

            }

            functions.getObjectFromAjax(

                "/resolutionsoftwareplatform/facility/scannavigator?buildingId="

                +

                buildingId,

                setNavigator,

                null

            );

        },

        [buildingId]

    );


    /* =========================================================
       DRAG EVENTS
       ========================================================= */

    useEffect(

        function()

        {

            function handleMouseMove(e)

            {

                if(!dragging)

                {

                    return;

                }

                setPosition(

                {

                    x:

                        e.clientX -

                        dragOffset.current.x,

                    y:

                        e.clientY -

                        dragOffset.current.y

                });

            }


            function handleMouseUp()

            {

                if(!dragging)

                {

                    return;

                }

                setDragging(false);


                /*
                 * Snap left / right
                 */

                const newSide =

                    position.x <

                    (window.innerWidth / 2)

                        ? "left"

                        : "right";


                setSide(

                    newSide

                );


                localStorage.setItem(

                    "scanNavigatorSide",

                    newSide

                );


                setPosition(

                    function()

                    {

                        return {

                            x:

                                newSide === "left"

                                    ? 90

                                    : window.innerWidth - 250,

                            y:

                                position.y

                        };

                    }

                );

            }


            window.addEventListener(

                "mousemove",

                handleMouseMove

            );

            window.addEventListener(

                "mouseup",

                handleMouseUp

            );


            return function()

            {

                window.removeEventListener(

                    "mousemove",

                    handleMouseMove

                );

                window.removeEventListener(

                    "mouseup",

                    handleMouseUp

                );

            };

        },

        [dragging, position]

    );


    /* =========================================================
       START DRAG
       ========================================================= */

    function startDrag(e)

    {

        setDragging(true);

        dragOffset.current =

        {

            x:

                e.clientX -

                position.x,

            y:

                e.clientY -

                position.y

        };

    }


    /* =========================================================
       TOGGLE COLLAPSE
       ========================================================= */

    function toggleCollapse(e)

    {

        /*
         * Prevent collapse button from starting
         * a navigator drag.
         */

        if(e)

        {

            e.stopPropagation();

        }

        setCollapsed(

            !collapsed

        );

    }


    /* =========================================================
       STYLES
       ========================================================= */


    /*
     * Main floating glass panel.
     *
     * Graphite structure with enough transparency
     * to retain the floating glass effect.
     */


	const container =
	{
	    position: "fixed",

	    left: position.x + "px",
	    top: position.y + "px",

	    width: "220px",

	    opacity: visible ? 1 : 0,

	    //--------------------------------------------------------
	    // Colourless Architectural Glass
	    //--------------------------------------------------------

	    background: "rgba(255,255,255,0.07)",

	    backdropFilter: "blur(12px) saturate(105%)",

	    WebkitBackdropFilter: "blur(12px) saturate(105%)",

	    //--------------------------------------------------------
	    // Subtle Glass Edge
	    //--------------------------------------------------------

	    border: "1px solid rgba(255,255,255,0.35)",

	    borderRadius: "0px",

	    boxShadow:
	        "0 12px 30px rgba(0,0,0,0.16), " +
	        "inset 0 1px 0 rgba(255,255,255,0.20)",

	    zIndex: 999999,

	    overflow: "hidden",

	    transform:
	        dragging
	            ? "scale(1.02)"
	            : "scale(1)",

	    transition:
	        dragging
	            ? "none"
	            : "opacity 1200ms ease, transform 220ms ease"
	};


    /*
     * Header
     */

    const header =

    {

        height:

            "54px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between",

        padding:

            "0 16px",

        borderBottom:

            "1px solid rgba(255,255,255,0.09)",

        cursor:

            "move",

        userSelect:

            "none",

        boxShadow:

            "inset 0 -1px 0 rgba(0,0,0,0.16)"

    };


    /*
     * Body
     */

    const body =

    {

        padding:

            collapsed

                ? "0px"

                : "14px",

        maxHeight:

            collapsed

                ? "0px"

                : "500px",

        overflow:

            "hidden",

        transition:

            "all 220ms ease"

    };


    /*
     * Main building button
     */

    const circle =

    {

        width:

            "48px",

        height:

            "48px",

        borderRadius:

            "50%",

        background:

            "linear-gradient(180deg,#30353a 0%,#171a1d 100%)",

        border:

            "1px solid rgba(255,255,255,0.12)",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        color:

            "#8dc8f0",

        fontWeight:

            700,

        cursor:

            "pointer",

        boxShadow:

            "0 4px 10px rgba(0,0,0,0.28), " +

            "inset 0 1px 0 rgba(255,255,255,0.08)",

        transition:

            "all 180ms ease"

    };


    /*
     * Floor row
     */

    const floorRow =

    {

        display:

            "flex",

        alignItems:

            "center",

        gap:

            "18px",

        marginTop:

            "12px",

        cursor:

            "pointer"

    };


    /*
     * Floor label
     */

    const floorLabel =

    {

        color:

            "#ffffff",

        fontSize:

            "14px",

        fontWeight:

            500,

        marginLeft:

            "4px"

    };


    /*
     * Collapse button
     */

    const collapseButton =

    {

        width:

            "28px",

        height:

            "28px",

        borderRadius:

            "50%",

        background:

            "rgba(255,255,255,0.07)",

        border:

            "1px solid rgba(255,255,255,0.12)",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        color:

            "#8dc8f0",

        cursor:

            "pointer",

        boxShadow:

            "inset 0 1px 0 rgba(255,255,255,0.06)",

        transition:

            "all 0.18s ease"

    };


    /*
     * AI action.
     *
     * Deliberately blue because this is an action,
     * rather than structural chrome.
     */

	const aiButton =
	{
	    marginTop:
	        "20px",

	    width:
	        "100%",

	    height:
	        "34px",

	    display:
	        "flex",

	    alignItems:
	        "center",

	    justifyContent:
	        "center",

	    boxSizing:
	        "border-box",

	    background:
	        "linear-gradient(180deg, #42bff5 0%, #159bd7 100%)",

	    color:
	        "#ffffff",

	    fontSize:
	        "12px",

	    fontWeight:
	        600,

	    borderRadius:
	        "0px",

	    border:
	        "1px solid rgba(66,191,245,0.40)",

	    cursor:
	        "pointer",

	    userSelect:
	        "none",

	    boxShadow:
	        "inset 0 1px 0 rgba(255,255,255,0.24), " +
	        "0 4px 12px rgba(21,155,215,0.22)",

	    transition:
	        "all 0.18s ease"
	};


    /* =========================================================
       RENDER GUARDS
       ========================================================= */

    if(!navigator)

    {

        return null;

    }


    if(!functions.getIsDemoSystem())

    {

        return null;

    }


    /* =========================================================
       RENDER
       ========================================================= */

    return (

        <div style={container}>


            {/* =================================================
                HEADER
            ================================================= */}

            <div

                style={header}

                onMouseDown={startDrag}

            >

                <div

                    style={{

                        color:

                            "#252b31",

                        fontWeight:

                            600,

                        fontSize:

                            "14px",

                        letterSpacing:

                            "0.2px"

                    }}

                >

                    Scan Navigator

                </div>


                <div

                    style={collapseButton}

                    onClick={

                        toggleCollapse

                    }

                    onMouseEnter={

                        function(e)

                        {

                            e.currentTarget.style.background =

                                "rgba(69,175,224,0.18)";

                            e.currentTarget.style.borderColor =

                                "rgba(141,200,240,0.34)";

                        }

                    }

                    onMouseLeave={

                        function(e)

                        {

                            e.currentTarget.style.background =

                                "rgba(255,255,255,0.07)";

                            e.currentTarget.style.borderColor =

                                "rgba(255,255,255,0.12)";

                        }

                    }

                >

                    <FontAwesomeIcon

                        icon={

                            collapsed

                                ? faChevronDown

                                : faChevronUp

                        }

                    />

                </div>

            </div>


            {/* =================================================
                BODY
            ================================================= */}

            <div style={body}>


                {/* =============================================
                    BUILDING
                ============================================= */}

                <div

                    style={{

                        display:

                            "flex",

                        alignItems:

                            "center",

                        gap:

                            "18px",

                        cursor:

                            "pointer"

                    }}

                    onClick={

                        function()

                        {

                            setSelectedFloorId(

                                null

                            );

                            if(

                                switchScan

                                &&

                                navigator.buildingCameraScan

                            )

                            {

                                switchScan(

                                    navigator.buildingCameraScan

                                );

                            }

                        }

                    }

                >

                    <div

                        style={circle}

                        onMouseEnter={

                            function(e)

                            {

                                e.currentTarget.style.background =

                                    "linear-gradient(180deg,#3b4146 0%,#202428 100%)";

                                e.currentTarget.style.borderColor =

                                    "rgba(141,200,240,0.42)";

                                e.currentTarget.style.transform =

                                    "translateY(-2px)";

                                e.currentTarget.style.boxShadow =

                                    "0 6px 14px rgba(0,0,0,0.32), " +

                                    "0 0 10px rgba(69,175,224,0.10)";

                            }

                        }

                        onMouseLeave={

                            function(e)

                            {

                                e.currentTarget.style.background =

                                    "linear-gradient(180deg,#30353a 0%,#171a1d 100%)";

                                e.currentTarget.style.borderColor =

                                    "rgba(255,255,255,0.12)";

                                e.currentTarget.style.transform =

                                    "translateY(0)";

                                e.currentTarget.style.boxShadow =

                                    "0 4px 10px rgba(0,0,0,0.28), " +

                                    "inset 0 1px 0 rgba(255,255,255,0.08)";

                            }

                        }

                    >

                        <FontAwesomeIcon

                            icon={faBuilding}

                        />

                    </div>


                    <div

                        style={{

                            color:

                                "#ffffff"

                        }}

                    >

                        <div

                            style={{

                                fontWeight:

                                    600,

                                fontSize:

                                    "14px"

                            }}

                        >

                            Building Scan

                        </div>

                    </div>

                </div>


                {/* =============================================
                    FLOORS
                ============================================= */}

                {

                    navigator.floors

                    &&

                    navigator.floors.map(

                        function(floor)

                        {

                            const selected =

                                selectedFloorId ===

                                floor.floorId;


                            return (

                                <div

                                    key={
                                        floor.floorId
                                    }

                                    style={
                                        floorRow
                                    }

                                    onClick={

                                        function()

                                        {

                                            setSelectedFloorId(

                                                floor.floorId

                                            );

                                            if(

                                                switchScan

                                                &&

                                                floor.floorCameraScan

                                            )

                                            {

                                                switchScan(

                                                    floor.floorCameraScan

                                                );

                                            }

                                        }

                                    }

                                >

                                    <div

                                        style={{

                                            ...circle,

                                            width:

                                                "42px",

                                            height:

                                                "42px",

                                            fontSize:

                                                "12px",

                                            //--------------------------------
                                            // Blue = current selection
                                            //--------------------------------

                                            background:

                                                selected

                                                    ?

                                                    "linear-gradient(180deg,#45afe0 0%,#2695cc 100%)"

                                                    :

                                                    "linear-gradient(180deg,#30353a 0%,#171a1d 100%)",

                                            color:

                                                selected

                                                    ? "#ffffff"

                                                    : "#8dc8f0",

                                            border:

                                                selected

                                                    ?

                                                    "1px solid rgba(141,200,240,0.72)"

                                                    :

                                                    "1px solid rgba(255,255,255,0.12)",

                                            boxShadow:

                                                selected

                                                    ?

                                                    "0 4px 12px rgba(38,149,204,0.30), " +

                                                    "inset 0 1px 0 rgba(255,255,255,0.24)"

                                                    :

                                                    "0 3px 8px rgba(0,0,0,0.24), " +

                                                    "inset 0 1px 0 rgba(255,255,255,0.06)"

                                        }}

                                        title={
                                            floor.floorName
                                        }

                                        onMouseEnter={

                                            function(e)

                                            {

                                                e.currentTarget.style.transform =

                                                    "translateY(-2px)";

                                            }

                                        }

                                        onMouseLeave={

                                            function(e)

                                            {

                                                e.currentTarget.style.transform =

                                                    "translateY(0)";

                                            }

                                        }

                                    >

                                        {floor.floorName}

                                    </div>


                                    <div

                                        style={{

                                            ...floorLabel,

                                            color:

                                                selected

                                                    ? "#ffffff"

                                                    : "rgba(255,255,255,0.82)"

                                        }}

                                    >

                                        {/*
                                         * Deliberately blank for now.
                                         * Floor name remains inside button
                                         * as per existing navigator.
                                         */}

                                    </div>

                                </div>

                            );

                        }

                    )

                }


                {/* =============================================
                    AI INSIGHTS
                ============================================= */}

                {

                    isLocalHost

                    &&

                    <div

                        onClick={

                            function()

                            {

                                setAiDrawerVisible(

                                    true

                                );

                            }

                        }

                        style={
                            aiButton
                        }

						onMouseEnter={
						    function(e)
						    {
						        e.currentTarget.style.background =
						            "linear-gradient(180deg, #59c8f7 0%, #20a7e3 100%)";

						        e.currentTarget.style.transform =
						            "translateY(-1px)";

						        e.currentTarget.style.boxShadow =
						            "inset 0 1px 0 rgba(255,255,255,0.30), " +
						            "0 6px 16px rgba(21,155,215,0.30)";
						    }
						}

						onMouseLeave={
						    function(e)
						    {
						        e.currentTarget.style.background =
						            "linear-gradient(180deg, #42bff5 0%, #159bd7 100%)";

						        e.currentTarget.style.transform =
						            "translateY(0)";

						        e.currentTarget.style.boxShadow =
						            "inset 0 1px 0 rgba(255,255,255,0.24), " +
						            "0 4px 12px rgba(21,155,215,0.22)";
						    }
						}

                    >

                        AI Insights & Assets

                    </div>

                }

            </div>

        </div>

    );

}